import React, { useState, useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import apiClient from 'apiClient';
import AdviserDetails from 'components/AdviserDetails/AdviserDetails';
import ErrorManager from 'shared/Messages/ErrorManager';
import { initialData, mapAdviserDataFromBackend, mapAdviserDataToBackend } from './utils';
import { FormData } from 'components/AdviserDetails/interface/AdviserDetailsInterface';

interface RouteProps {
  id: string;
}

const AdviserDetailsPage: React.FC<RouteComponentProps<RouteProps>> = ({ match }) => {
  const [adviserDetails, setAdviserDetails] = useState<FormData>(initialData);
  const [isSaved, setIsSaved] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const { id } = match.params;

  useEffect(() => {
    let shouldCancel = false;

    const getAdviserDetails = async () => {
      try {
        const res = await apiClient.get(`/api/v1/broker-management/advisers/${id}`);
        if (!shouldCancel) setAdviserDetails(mapAdviserDataFromBackend(res.data));
      } catch (error) {
        if (!shouldCancel) setError(error.response);
      }
    };

    getAdviserDetails();

    return () => {
      shouldCancel = true;
    };
  }, [id]);

  const handleSubmit = async (values: FormData) => {
    const dataToBackend = mapAdviserDataToBackend(values);
    try {
      await apiClient.post(`/api/v1/broker-management/update-adviser/${id}`, dataToBackend);
      setIsSaved(true);
    } catch (error) {
      setIsSaved(false);
      setError(error.response);
    }
  };

  return (
    <>
      <AdviserDetails onSubmit={handleSubmit} details={adviserDetails} isSaved={isSaved} />
      {error && !isSaved && <ErrorManager error={error} />}
    </>
  );
};

export default AdviserDetailsPage;
